/** Shared notification bell glyph for CRM / DEM topbars. */
export function NotificationBellIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M12 3.75c-2.9 0-5.25 2.2-5.25 4.9v1.7c0 .86-.28 1.7-.8 2.4L4.7 14.7a1.35 1.35 0 0 0 1.08 2.15h12.44a1.35 1.35 0 0 0 1.08-2.15l-1.25-1.95a4.1 4.1 0 0 1-.8-2.4V8.65c0-2.7-2.35-4.9-5.25-4.9Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M9.6 16.85a2.5 2.5 0 0 0 4.8 0"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}
